<template>
  <div class="wrapper-content wrapper-content--fixed">
    <section>
      <div class="container">
        <h1 class="title">Нет такой страницы!</h1>
        <p>Перейти <router-link class="link" :to="{ name: 'main' }">на главную?</router-link></p>
      </div>
    </section>
  </div>
</template>

<script>
    export default {
        name: "Error404Page"
    }
</script>

<style scoped>

</style>